import { GameMode } from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";

export class AbstractGameMode extends GameMode {
    //Add your custom modes here!
    public static readonly NORMAL_AVALANCHE: string = `NORMAL_AVALANCHE`;
    public static readonly RESPIN: string = `RESPIN`;
    public static readonly FREESPIN_BETTER: string = `FREESPIN_BETTER`;
    public static readonly SUPER_FREESPIN: string = `SUPER_FREESPIN`;
}
